const PATHNAME = window.location.pathname
const ISQA = PATHNAME.includes('qa');
const PROTOCOL = window.location.protocol
export const API_HOST = process.env.NODE_ENV === 'production' && !ISQA ? PROTOCOL + '//bg.fjyszn.com/' : PROTOCOL + '//bg.fjyszn.com/qa'
// export const API_HOST = process.env.NODE_ENV === 'production' && !ISQA? 'http://bg1.fjyszn.com/' : 'http://bg1.fjyszn.com/qa'
